<div class="wrapper">
  <div class="header-content">
    <ng-content></ng-content>
  </div>
  <div (resizable)="onResize($event)" class="bar"></div>
</div>
